import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SharedCallsService } from '../../shared/services/shared-calls.service';
import { Adal5Service } from 'adal-angular5';
import { LocalCacheService } from '../local-cache/local-cache.service';

@Injectable()
export class AuthorizationMarketerGuard implements CanActivate, CanActivateChild {
    
  constructor(
    private sharedSerice: SharedCallsService,
    private adalSvc: Adal5Service,
    private storage: LocalCacheService
  ) { }

  getUserRole() {
    this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').subscribe(response => {
        if (response.status === 200) {
          return (response.result.roleName.toLowerCase() === 'marketer');
        } else {
            return false;
        }
    });
  }

  canActivate(): Observable<boolean> | boolean {
    return this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').map(response => {
        if (response.status === 200) {
          return (response.result.roleName.toLowerCase() === 'marketer' || response.result.roleName.toLowerCase() === 'admin');
        } else {
            return false;
        }
    });
  }

  canActivateChild(): boolean | Observable<boolean> | Promise<boolean> {
    return this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').map(response => {
        if (response.status === 200) {
          return (response.result.roleName.toLowerCase() === 'marketer' || response.result.roleName.toLowerCase() === 'admin');
        } else {
            return false;
        }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/authorization/authorization-marketer-guard.ts